/**
 * Parses a date string in YYYY-MM-DD format to MM/DD/YYYY format.
 * @param date - Date string in YYYY-MM-DD format or null
 * @returns Formatted date string in MM/DD/YYYY format or '00/00/0'
 */
export const parseDateToString = (date: string | null): string => {
  const [year, month, day] = date ? date.split('-').map(Number) : [0, 0, 0];
  const monthString = month < 10 ? `0${month}` : `${month}`;
  const dayString = day < 10 ? `0${day}` : `${day}`;
  return `${monthString}/${dayString}/${year}`;
};

/**
 * Converts date strings or DateTime objects from MM/DD/YYYY to YYYY-MM-DD format.
 * @param startDate - Start date in MM/DD/YYYY or DateTime format
 * @param endDate - End date in MM/DD/YYYY or DateTime format
 * @returns Array [newStartDate, newEndDate] in YYYY-MM-DD format or empty strings
 */
export const modifyDateFormat = (
  startDate: string | { toString: () => string } | null,
  endDate: string | { toString: () => string } | null,
): [string, string] => {
  const modifiedStartDate = startDate?.toString().split('/');
  const modifiedEndDate = endDate?.toString().split('/');

  const newStartDate =
    modifiedStartDate && modifiedStartDate.length === 3
      ? `${modifiedStartDate[2]}-${modifiedStartDate[0]}-${modifiedStartDate[1]}`
      : '';
  const newEndDate =
    modifiedEndDate && modifiedEndDate.length === 3
      ? `${modifiedEndDate[2]}-${modifiedEndDate[0]}-${modifiedEndDate[1]}`
      : '';

  return [newStartDate, newEndDate];
};
